var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"block_"},[_c('img',{staticClass:"swiper_img",attrs:{"src":require("@/assets/images/about/about.png"),"alt":"Slide 1"}})])])
}]

export { render, staticRenderFns }